import {CanvasDataByType, DataState, OncePageCanvasData} from "./interface/dataInterface"
import {Action} from "./interface/baseInterface"

const dataState = {
    model: null,
    attachmentList: [],
    historicalDataList: [],
    errorLog: {
        type: "",
        data: {
            title: "",
            msg: "",
            onOk: null,
            onCancel: null,
        },
    },
    historicalControl: {deleteId: 0},
    scaleScal: 0.5,
    imageList: {baseList: [], compareList: []},
    canvasData: {baseData: [], compareData: []},
    listData: {insert: [], replace: [], delete: []},
    jumpDesc: {
        posBase: [],
        posCompare: [],
        pageBase: [0],
        pageCompare: [0],
    },
    onSelectShape: null,
    listJump: null,
    caluShapeFromPos: null,
    shapeFromPos: null,
    hoverItem: null,
    lastHoverItem: null,
    adaptWindow: false,
}

export function dataReducer(state: DataState = dataState, action: Action) {
    const payload = action.payload
    switch (action.type) {
        // global
        case "TDAInit": {
            return {
                ...dataState,
            }
        }
        case "showErrorLog": {
            return {
                ...state,
                errorLog: payload,
            }
        }
        case "dataInit": {
            return {
                ...dataState,
            }
        }
        case "queryDataStatus":
            return {
                ...state,
                imageList: payload.data.imageList,
                canvasData: payload.data.canvasData,
                listData: payload.data.listData,
            }
        // TODO 重构 ，重构完上面删了
        case "changeAttachMent":
            return {
                ...state,
                attachmentList: payload,
            }
        case "setHistoricalDataList":
            return {
                ...state,
                historicalDataList: payload,
            }
        // case "changeHoverDiffitem":
        //     return {
        //         ...state,
        //         lastHoverItem: state.hoverItem,
        //         hoverItem: payload,
        //     }
        case "changeScaleScal":
            return {
                ...state,
                scaleScal: payload,
            }
        case "onSelectShape":
            return {
                ...state,
                onSelectShape: payload,
            }
        case "pollingSuccess":
            return {
                ...state,
                onSelectShape: null,
                hoverItem: null,
                lastHoverItem: null,
            }
        // eslint-disable-next-line no-duplicate-case
        case "changeHoverDiffitem":
            let base: OncePageCanvasData | null = null
            let compare: OncePageCanvasData | null = null
            state.canvasData.baseData.forEach((item) => {
                item[payload.diffType].forEach((baseItem: OncePageCanvasData) => {
                    if (baseItem.diffIndex === payload.diffIndex) {
                        base = baseItem
                    }
                })
            })
            state.canvasData.compareData.forEach((item) => {
                item[payload.diffType].forEach((compareItem: OncePageCanvasData) => {
                    if (compareItem.diffIndex === payload.diffIndex) {
                        compare = compareItem
                    }
                })
            })
            return {
                ...state,
                lastHoverItem: state.hoverItem,
                hoverItem: payload,
                onSelectShape: {
                    // @ts-ignore
                    pageBase: [base.locationShape.pageNum],

                    // @ts-ignore
                    pageCompare: [compare.locationShape.pageNum],

                    // @ts-ignore
                    posBase: [base.locationShape],

                    // @ts-ignore
                    posCompare: [compare.locationShape],
                },
            }
        case "onJump":
            return {
                ...state,
                jumpDesc: payload,
            }
        case "onListJump":
            return {
                ...state,
                listJump: payload,
            }
        case "onCaluShapeFromPos":
            return {
                ...state,
                caluShapeFromPos: payload,
            }
        case "saveShapeFromPos":
            return {
                ...state,
                shapeFromPos: payload,
            }
        case "adaptWindow":
            return {
                ...state,
                adaptWindow: !state.adaptWindow,
            }
        case "setDeleteHistoricalDetailId":
            return {
                ...state,
                historicalControl: {...state.historicalControl, deleteId: payload},
            }
        case "doDeleteHistorical":
            return {
                ...state,
                historicalDataList: state.historicalDataList
                    .filter((item) => item.id !== state.historicalControl.deleteId)
                    .map((item, index) => {
                        return {
                            ...item,
                            index: index + 1,
                        }
                    }),
                historicalControl: dataState.historicalControl,
            }
        default:
            return state
    }
}
